import {
  CalculationType,
  CompensationRateType,
  CompensationUnit,
  TimeConditionType,
} from 'modules/employees/pages/BulkFixContractsPage/types'

interface SetLegalEntityAction {
  type: 'setLegalEntity'
  payload: string
}
export function setLegalEntityAction(legalEntityId: string): SetLegalEntityAction {
  return {
    type: 'setLegalEntity',
    payload: legalEntityId,
  }
}

interface SetPolicyAction {
  type: 'setPolicy'
  payload: string
}
export function setPolicyAction(policyId: string): SetPolicyAction {
  return {
    type: 'setPolicy',
    payload: policyId,
  }
}

interface SetTaxonomyAction {
  type: 'setTaxonomy'
  payload: { id: string; name: string } | null
}
export function setTaxonomyAction(payload: { id: string; name: string } | null): SetTaxonomyAction {
  return {
    type: 'setTaxonomy',
    payload,
  }
}

interface SetRateTypeAction {
  type: 'setRateType'
  payload: CompensationRateType | null
}
export function setRateTypeAction(
  compensationRateType: CompensationRateType | null
): SetRateTypeAction {
  return {
    type: 'setRateType',
    payload: compensationRateType,
  }
}

interface SetDescriptionAction {
  type: 'setDescription'
  payload: string
}
export function setDescriptionAction(description: string): SetDescriptionAction {
  return {
    type: 'setDescription',
    payload: description,
  }
}

interface SetAmountAction {
  type: 'setAmount'
  payload: string | null
}
export function setAmountAction(amount: string | null): SetAmountAction {
  return {
    type: 'setAmount',
    payload: amount,
  }
}

// Unit or currency
interface SetAmountTypeAction {
  type: 'setAmountType'
  payload: CompensationUnit
}
export function setAmountTypeAction(amountType: CompensationUnit): SetAmountTypeAction {
  return {
    type: 'setAmountType',
    payload: amountType,
  }
}

interface SetSyncWithPayrollAction {
  type: 'setSyncWithPayroll'
  payload: boolean
}
export function setSyncWithPayrollAction(syncWithPayroll: boolean): SetSyncWithPayrollAction {
  return {
    type: 'setSyncWithPayroll',
    payload: syncWithPayroll,
  }
}

interface SetRecurrenceCountAction {
  type: 'setRecurrenceCount'
  payload: number
}
export function setRecurrenceCountAction(recurrenceCount: number): SetRecurrenceCountAction {
  return {
    type: 'setRecurrenceCount',
    payload: recurrenceCount,
  }
}

interface SetStartsOnAction {
  type: 'setStartsOn'
  payload: string
}
/**
 * @param startsOn an ISO8601 date string
 */
export function setStartsOnAction(startsOn: string): SetStartsOnAction {
  return {
    type: 'setStartsOn',
    payload: startsOn,
  }
}

// TODO: Improve type of recurrence upstream in Compensation definition
interface SetRecurrenceAction {
  type: 'setRecurrence'
  payload: string
}
export function setRecurrenceAction(recurrence: string): SetRecurrenceAction {
  return {
    type: 'setRecurrence',
    payload: recurrence,
  }
}

interface SetFirstPaymentAction {
  type: 'setFirstPayment'
  payload: string
}
/**
 * @param firstPayment ISO8601 date string
 */
export function setFirstPaymentAction(firstPayment: string): SetFirstPaymentAction {
  return {
    type: 'setFirstPayment',
    payload: firstPayment,
  }
}

interface SetPerWorkedDayCalculationAction {
  type: 'setPerWorkedDayCalculation'
  payload: CalculationType
}
export function setPerWorkedDayCalculationAction(
  calculationType: CalculationType
): SetPerWorkedDayCalculationAction {
  return {
    type: 'setPerWorkedDayCalculation',
    payload: calculationType,
  }
}

interface SetTimeConditionAction {
  type: 'setTimeCondition'
  payload: TimeConditionType | null
}
export function setTimeConditionAction(
  timeConditionType: TimeConditionType | null
): SetTimeConditionAction {
  return {
    type: 'setTimeCondition',
    payload: timeConditionType,
  }
}

interface SetMinimumAmountOfHoursAction {
  type: 'setMinimumAmountOfHours'
  payload: number | null
}
export function setMinimumAmountOfHoursAction(
  minimumAmountOfHours: number
): SetMinimumAmountOfHoursAction {
  return {
    type: 'setMinimumAmountOfHours',
    payload: minimumAmountOfHours,
  }
}

export type CompensationUpdateAction =
  | SetLegalEntityAction
  | SetPolicyAction
  | SetTaxonomyAction
  | SetDescriptionAction
  | SetRateTypeAction
  | SetAmountAction
  | SetAmountTypeAction
  | SetSyncWithPayrollAction
  | SetRecurrenceCountAction
  | SetStartsOnAction
  | SetRecurrenceAction
  | SetFirstPaymentAction
  | SetPerWorkedDayCalculationAction
  | SetTimeConditionAction
  | SetMinimumAmountOfHoursAction
